import { render, staticRenderFns } from "./bundles.vue?vue&type=template&id=230973ba&"
import script from "./bundles.vue?vue&type=script&lang=js&"
export * from "./bundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports